import { PopoverProps as PopoverPrimitiveProps } from '@mui/material';
import { ReactNode } from 'react';

export interface PopoverActions {
  open: () => void;
  close: () => void;
}

export interface PopoverProps extends Omit<PopoverPrimitiveProps, 'open' | 'ref'> {
  onOpen?: () => void;
  trigger: ReactNode;
  disabled?: boolean;
  /** @deprecated this is not used anymore, propagation should already be stopped */
  enableStopPropagation?: boolean;
}

export const extractTrigger = (element: Element | null): Element | null => {
  if (!element) return null;
  const display = getComputedStyle(element).getPropertyValue('display');
  if (display === 'none') return null;
  if (display !== 'contents') return element;
  for (let child = element.firstChild; child !== null; child = child.nextSibling) {
    const trigger = extractTrigger(child as Element);
    if (trigger) return trigger;
  }
  return null;
};
